@if (loading) {
  <div class="loader-container flex flex-col items-center justify-center">
    @if (!progression) {
      <div class="loader-backdrop" [class.full-screen]="config().fullScreenBackdrop"
      [style.border-radius]="config().backdropBorderRadius" [style.background-color]="config().backdropBackgroundColour"></div>
      <div class="sk-cube-grid" [class.full-screen]="config().fullScreenBackdrop">
        @for (cube of cubes; track cube) {
          <div class="sk-cube sk-cube{{ cube }}" [style.background-color]="config().primaryColour"></div>
        }
      </div>
    }
    @if (progression) {
      <div class="w-full">
        <h1>{{ progression.activity || 'Processing' }}...</h1>
        <mat-progress-bar [mode]="select_mode" value="{{ progression.value * 100 }}" />
      </div>
    }
  </div>
}